export default [
  {
    path: "/ptf-beneficiaire/news",
    name: "news",
    component: () => import("@/views/ptf-beneficiaire/news/Index.vue"),
    meta: {
      pageTitle: "Plateforme bénéficiaire",
      breadcrumb: [
        {
          text: "Gestion des news",
          active: true,
        },
      ],
      rights: ["PTF_BENEFICIAIRE_NEWS:read"],
    },
  },
  {
    path: '/manage-meetings',
    name: 'manage-meetings',
    component: () => import('@/views/ptf-beneficiaire/meetings/Index.vue'),
    meta: {
      pageTitle: 'Gestion des rendez-vous',
      breadcrumb: [
        {
          text: 'Gestion des rendez-vous',
          active: true,
        },
      ],
      rights: [
        'PTF_BENEFICIAIRE_MEETINGS:read'
      ]
    },
  },
  {
    path: '/manage-meetings/:id',
    name: 'manage-meetings-intervenant',
    component: () => import('@/views/ptf-beneficiaire/meetings/Details.vue'),
    meta: {
      pageTitle: 'Gestion des rendez-vous',
      breadcrumb: [
        {
          text: 'Gestion des rendez-vous',
          active: true,
        },
      ],
      rights: [
        'PTF_BENEFICIAIRE_MEETINGS:read'
      ]
    },
  },
  {
    path: '/manage-beneficiaires',
    name: 'manage-beneficiaires',
    component: () => import('@/views/ptf-beneficiaire/beneficiaires/Index.vue'),
    meta: {
      pageTitle: 'Gestion des bénéficiaires',
      breadcrumb: [
        {
          text: 'Gestion des bénéficiaires',
          active: true,
        },
      ],
      rights: [
        'PTF_BENEFICIAIRE_BENEFICIAIRES:read',
        'PTF_BENEFICIAIRE_BENEFICIAIRES:admin',
        'PTF_BENEFICIAIRE_MES_BENEFICIAIRES:read'
      ]
    },
  },{
    path: '/manage-beneficiaires-meetings/:id',
    name: 'manage-beneficiaires-meetings',
    component: () => import('@/views/ptf-beneficiaire/beneficiaires/Details.vue'),
    meta: {
      pageTitle: 'Gestion des rendez-vous d\'un bénéficiaire',
      breadcrumb: [
        {
          text: 'Gestion des rendez-vous d\'un bénéficiaire',
          active: true,
        },
      ],
      rights: [
        'PTF_BENEFICIAIRE_BENEFICIAIRES:read',
        'PTF_BENEFICIAIRE_BENEFICIAIRES:admin',
        'PTF_BENEFICIAIRE_MES_BENEFICIAIRES:read'
      ]
    },
  },
  {
    path: "/ptf-beneficiaire/demandesAcces",
    name: "demandesAcces",
    component: () => import("@/views/ptf-beneficiaire/demandesAcces/Index.vue"),
    meta: {
      pageTitle: "Plateforme bénéficiaire",
      breadcrumb: [
        {
          text: "Gestion des demandes",
          active: true,
        },
      ],
      rights: ["PTF_BENEFICIAIRE_DEMANDEACCES:read"],
    },
  },
];
